import React, { useEffect, useState } from 'react';
import { useLang } from '../../context/LanguageContext';
import { Button } from '../../components/ui/button';
import { adminListNewsletter } from '../../api';
import { toast } from '../../hooks/use-toast';
import { Mail, Download, Copy } from 'lucide-react';

const AdminNewsletter = () => {
  const { lang } = useLang();
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminListNewsletter().then(setSubs).catch(() => toast({ title: 'Load failed', variant: 'destructive' })).finally(() => setLoading(false));
  }, []);

  const copyAll = () => {
    const text = subs.map(s => s.email).join(', ');
    navigator.clipboard.writeText(text);
    toast({ title: lang === 'ar' ? 'تم النسخ' : 'Copied to clipboard' });
  };

  const exportCSV = () => {
    const csv = 'email,created_at\n' + subs.map(s => `${s.email},${s.created_at || ''}`).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'newsletter_subscribers.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-display text-3xl md:text-4xl text-[#0a0a0a]">{lang === 'ar' ? 'مشتركون النشرة' : 'Newsletter Subscribers'}</h1>
          <p className="text-sm text-[#111827]/60 mt-2">{subs.length} {lang === 'ar' ? 'مشترك' : 'subscribers'}</p>
        </div>
        <div className="flex gap-2">
          <Button onClick={copyAll} disabled={!subs.length} className="ghost-button rounded-md h-10 px-4 text-xs bg-transparent"><Copy className="w-3.5 h-3.5 me-2" /> {lang === 'ar' ? 'نسخ الكل' : 'Copy All'}</Button>
          <Button onClick={exportCSV} disabled={!subs.length} className="gold-button rounded-md h-10 px-4 text-xs"><Download className="w-3.5 h-3.5 me-2" /> {lang === 'ar' ? 'تصدير CSV' : 'Export CSV'}</Button>
        </div>
      </div>

      {loading ? <div className="glass-card rounded-2xl p-10 text-center text-[#111827]/60">…</div>
      : subs.length === 0 ? <div className="glass-card rounded-2xl p-10 text-center text-[#111827]/60">{lang === 'ar' ? 'لا يوجد مشتركون' : 'No subscribers yet'}</div>
      : (
        <div className="glass-card rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-[#2563eb]/8 border-b border-[#2563eb]/15">
                <tr className="text-[10px] uppercase tracking-widest text-[#2563eb]">
                  <th className="p-3 text-start">Email</th>
                  <th className="p-3 text-start">{lang === 'ar' ? 'تاريخ الاشتراك' : 'Subscribed'}</th>
                </tr>
              </thead>
              <tbody>
                {subs.map((s) => (
                  <tr key={s.id} className="border-b border-[#2563eb]/8 hover:bg-[#2563eb]/4">
                    <td className="p-3 flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-[#2563eb]" /> <span className="text-[#0a0a0a]">{s.email}</span></td>
                    <td className="p-3 text-xs text-[#111827]/60">{s.created_at ? new Date(s.created_at).toLocaleString() : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminNewsletter;
